import React, { useCallback, useContext } from "react";
import { RiRemoteControlLine } from "react-icons/ri";
import { AppCtx } from "../../../AppCtx";
import { ThemeContext } from "../../../ThemeContext";

/** @deprecated Hidden from the read-only catalogue menu. */
const PresentationPilotButtonComponent = () => {
  const {
    isPresentationMode,
    isPresentationControlPanelVisible,
    setPresentationControlPanelVisible
  } = useContext(AppCtx);
  const { theme } = useContext(ThemeContext);

  const handleToggle = useCallback(() => {
    setPresentationControlPanelVisible((prev) => !prev);
  }, [setPresentationControlPanelVisible]);

  const isActive = isPresentationControlPanelVisible;

  const buttonStyle = {
    cursor: "pointer",
    borderRadius: "30%",
    padding: "5px",
    backgroundColor: isActive
      ? "var(--active-item-bg-color)"
      : "transparent",
    border: "none",
    outline: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease, color 0.2s ease",
  };

  const iconStyle = {
    width: "20px",
    height: "20px",
    color: isActive
      ? "var(--active-item-text-color)"
      : theme === "dark"
        ? "var(--icon-color-dark)"
        : "var(--menu-icon-inactive-color)",
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      style={buttonStyle}
      aria-label={isPresentationMode ? "Sterowanie prezentacją" : "Steruj prezentacją z innego urządzenia"}
      title={isPresentationMode ? "Sterowanie prezentacją" : "Steruj prezentacją z innego urządzenia"}
      aria-pressed={isPresentationControlPanelVisible}
    >
  <RiRemoteControlLine style={iconStyle} />
    </button>
  );
};

export default PresentationPilotButtonComponent;
